export default __webpack_public_path__ + "static/media/iFitTokenBR.3c3c06c1.png";